import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";

import MoveLayerUpButton from "./MoveLayerUpButton";
import MoveLayerDownButton from "./MoveLayerDownButton";
import Split from "./Split";
import { CreatomateContext } from "../../contexts/VideoStudioContext";
import { VIDEO_TYPE } from "../../utils/constants";
import PlayPauseButton from "./PlayPauseButton";
import Seekbar from "./Seekbar";
import TimelineZoom from "./TimelineZoom";
import { usePreviewTime } from "../../contexts/TimeContext";

interface ToolbarProps {
  preview?: Preview;
}

const Toolbar: React.FC<ToolbarProps> = ({ preview }) => {
  const { time } = usePreviewTime();
  const { data, getActiveElement } = useContext(CreatomateContext);
  const { mediaType } = data;
  const activeElement = preview ? getActiveElement(preview) : undefined;

  return (
    <div className="Toolbar-Editor">
      <div className="Toolbar-Editor__Controls">
        <div className="Up-Down-Btn">
          <MoveLayerUpButton activeElement={activeElement} preview={preview} />
          <MoveLayerDownButton activeElement={activeElement} preview={preview} />
          {mediaType === VIDEO_TYPE && preview && <Split preview={preview} />}
        </div>
        {mediaType === VIDEO_TYPE && (
          <>
            <div className="Preview-Editor__Controls-Play">
              <PlayPauseButton preview={preview} />
              <Seekbar preview={preview} time={time} />
            </div>
            <div className="Video-Utilities">
              <TimelineZoom initialZoom={65} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
